import ReactDOM from 'react-dom'
import { DashboardApp } from './DashboardApp'
import './styles/app.scss'

ReactDOM.render(<DashboardApp />, document.getElementById('root'))
